import { isArray, isObject, isFunction } from 'lodash';
import { flattenObject } from 'helpers/misc';

function validateModelKeys(model) {
  return (
    isArray(model.fields) &&
    isArray(model.requiredFields) &&
    isObject(model.initialValues) &&
    isFunction(model.validate)
  );
}

function allKeysExistIn(target, source) {
  return source.every(k => target.includes(k));
}

export function model(obj) {
  // validate model obj has the required keys
  // validate all requiredFields appear in 'fields'
  // validate all initialValues appear in 'fields'
  // validate all keys returned from validation appear in 'fields'
  if (!validateModelKeys(obj)) {
    throw new Error('model keys failed to validate');
  }

  if (!allKeysExistIn(obj.fields, obj.requiredFields)) {
    throw new Error('some keys in "requiredFields" were not found in "fields"');
  }

  if (
    !allKeysExistIn(obj.fields, Object.keys(flattenObject(obj.initialValues)))
  ) {
    throw new Error('some keys in "initialValues" were not found in "fields"');
  }

  if (
    !allKeysExistIn(obj.fields, Object.keys(flattenObject(obj.validate({}))))
  ) {
    throw new Error('some keys in "validate" were not found in "fields"');
  }

  // transform "fields" to obj constants
  //   ['a'] => { a: 'a' }
  return {
    ...obj,
    fields: obj.fields.reduce((result, fieldName) => {
      result[fieldName] = fieldName;
      return result;
    }, {})
  };
}



// WEBPACK FOOTER //
// ./src/client/helpers/model/index.js